/**
 * Service per impostare lo stato di sospensione di uno studente
 * Imposta disabled = 1 e data_sospensione = NOW() quando si sospende
 * Imposta disabled = 0 quando si riattiva
 */

import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function setSospensioneStudente(
  uname,
  token,
  id_studente,
  disabled
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "setSospensioneStudente.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        resolve(body.toString());
      });

      res.on("error", function(error) {
        reject(error);
      });
    });

    var postData = qs.stringify({
      uname: uname,
      token: token,
      id_studente: id_studente,
      disabled: disabled,
    });

    req.write(postData);
    req.end();
  });
}
